<footer class="footer">
  <div class="footer-inner">
    <div class="footer-logo">
      <a routerLink="/">
        <img
          src="assets/logo/actively_logo_rgb_name_white.png"
          alt="Actively Logo"
          class="footer-logo-img"
        />
      </a>
    </div>

    <div class="footer-copy">
      &copy; 2026 Actively. {{ 'All rights reserved.' | translate }} {{ gitHash }}
    </div>

    <nav class="footer-legal">
      <a routerLink="/terms">{{ 'terms_title' | translate }}</a>
      <a routerLink="/privacy">{{ 'privacy_title' | translate }}</a>
    </nav>

    <div class="footer-social">
      <a
        href="https://www.instagram.com/activelygr/"
        target="_blank"
        rel="noopener noreferrer"
        class="footer-social-link"
      >
        <i class="pi pi-instagram footer-social-icon"></i>
        <span class="footer-social-handle">{{ '@actively' }}</span>
      </a>
    </div>
  </div>
</footer>
